var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 16",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.192 13.624c.38 0 .68-.152.89-.463l5.94-9.166c.152-.23.216-.438.216-.635a.87.87 0 00-.914-.895c-.368 0-.6.127-.812.482l-5.345 8.455-2.73-3.44c-.216-.26-.438-.38-.755-.38-.54 0-.927.38-.927.908 0 .23.076.444.273.673l3.282 4.03c.248.298.52.432.882.432z",
    fill: "currentColor"
  })));
}

export default SvgCheckmark;